import { BackOfficeNotificationListReq } from "domain/payload/request/backOfficeNotification/BackOfficeNotificationReq";
import axiosInstance from "../config/AxiosConfig";
import { BaseResponse } from "domain/payload/response/BaseResponseDto";
import { BackOfficeNotificationListResponse, BackOfficeNotificationUnreadCountResponse } from "domain/payload/response/backOfficeNotification/BackOfficeNotificationResp";

const BackOfficeNotificationService = () => {
    const backOfficeNotificationList = async (
        token: string,
        params?: BackOfficeNotificationListReq
    ): Promise<BaseResponse<BackOfficeNotificationListResponse>> => {
        try {
            const queryParams: any = {};
            if (params) {
                if (params.page !== undefined) queryParams.page = params.page;
                if (params.size !== undefined) queryParams.size = params.size;
                if (params.search !== undefined) queryParams.search = params.search;
                if (params.projectId !== undefined) queryParams.project_id = params.projectId;
                if (params.isRead !== undefined) queryParams.is_read = params.isRead;
            }

            const response = await axiosInstance.get("/v1/legacy/cms/back-office-notification/list", {
                headers: {
                    Authorization: `Bearer ${token}`,
                },
                params: queryParams,
            });
            return response.data;
        } catch (error: any) {
            throw error.response?.data?.message || error.message;
        }
    };

    const backOfficeNotificationGetUnreadCount = async (
        token: string,
        projectId?: string
    ): Promise<BaseResponse<BackOfficeNotificationUnreadCountResponse>> => {
        try {
            const response = await axiosInstance.get(
                "/v1/legacy/cms/back-office-notification/unread-count",
                {
                    headers: {
                        Authorization: `Bearer ${token}`,
                    },
                    params: projectId ? { project_id: projectId } : {},
                }
            );
            return response.data;
        } catch (error: any) {
            throw error.response?.data?.message || error.message;
        }
    };

    const backOfficeNotificationMarkAsRead = async (
        token: string,
        id: string
    ): Promise<BaseResponse<any>> => {
        try {
            const response = await axiosInstance.put(
                `/v1/legacy/cms/back-office-notification/read/${id}`,
                {},
                {
                    headers: {
                        Authorization: `Bearer ${token}`,
                    },
                }
            );
            return response.data;
        } catch (error: any) {
            throw error.response?.data?.message || error.message;
        }
    };

    const backOfficeNotificationMarkAllAsRead = async (
        token: string,
        projectId?: string
    ): Promise<BaseResponse<any>> => {
        try {
            const body = projectId ? { project_id: projectId, projectId } : {};
            const response = await axiosInstance.put(
                "/v1/legacy/cms/back-office-notification/read-all",
                body,
                {
                    headers: {
                        Authorization: `Bearer ${token}`,
                    },
                    params: projectId ? { project_id: projectId, projectId } : {},
                }
            );
            return response.data;
        } catch (error: any) {
            throw error.response?.data?.message || error.message;
        }
    };

    const backOfficeNotificationDelete = async (
        token: string,
        id: string
    ): Promise<BaseResponse<any>> => {
        try {
            const response = await axiosInstance.delete(
                `/v1/legacy/cms/back-office-notification/delete/${id}`,
                {
                    headers: {
                        Authorization: `Bearer ${token}`,
                    },
                }
            );
            return response.data;
        } catch (error: any) {
            throw error.response?.data?.message || error.message;
        }
    };

    return {
        backOfficeNotificationList,
        backOfficeNotificationGetUnreadCount,
        backOfficeNotificationMarkAsRead,
        backOfficeNotificationMarkAllAsRead,
        backOfficeNotificationDelete,
    };
};

export default BackOfficeNotificationService;